// @flow

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';
import { Button as BSButton } from 'reactstrap';
import { ThemeColors } from 'trustar-2.0/themes/default';
import type { TextColorType } from 'trustar-2.0/types';
import { FormFeedback as BSFormFeedback } from 'reactstrap';

type FormFeedbackPropType = {
  children: ?Node,
  inline: boolean,
  tag: ?(Function | string),
  valid: boolean,
  tooltip: boolean,
};

export const FormFeedback = (props: FormFeedbackPropType) => {
  const FormFeedback = styled(BSFormFeedback)`

  `;
  return <FormFeedback {...props} />;
};

FormFeedback.defaultProps = {
  valid: false,
  tooltip: false,
};

export default FormFeedback;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Form/FormFeedback.js